import { IfWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('If')
export class IfNodeSchemaProvider extends SchemaProvider<IfWorkflowNode> {}
